declare global {
  /**
   * ISO 8601 timestamp of when this bundle was built, replaced literally by
   * vite's `define` (see vite.config.ts). Undefined in code that never went
   * through a vite build, e.g. unit tests.
   */
  var __BUILD_TIME__: string | undefined;
}

/**
 * When the running frontend bundle was built. `window.CONFIG.GIT_TAG` already
 * identifies the commit, but reading a date is faster than cross-referencing a
 * hash to tell whether a session is running a stale build.
 */
export const BUILD_TIME = globalThis.__BUILD_TIME__;
